import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import type { PropType } from 'vue';
import { toRefs, computed } from 'vue';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

/**
 * Viewmodel
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'QCustomFab',
  props: {
  display: { required: true, type: Boolean, default: false },
  label: { required: true, type: String },
  alt: { required: true, type: String },
  action: { required: true, type: Function },
  icon: { required: false, type: String, default: 'arrow_upward' },
  offset: { required: false, type: Object as PropType<Array<number>> },
},
  setup(__props) {

// Vendor
const { isMobile } = useGlobalVM();

/**
 *  Properties
 */
const props = __props;
const { display, label, alt, icon, action, offset } = toRefs(props);

/**
 * computed properties
 */
const newOffset = computed<Array<number>>(() =>
  offset?.value == null || offset.value.length === 0
    ? [18, isMobile.value ? 18 : 54]
    : offset.value,
);

/**
 * Methods
 */
function executeAction() {
  action.value();
}

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(display))
      ? (_openBlock(), _createBlock(_component_q_space, {
          key: 0,
          class: "q-mb-xl"
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(display))
          ? (_openBlock(), _createBlock(_component_q_page_sticky, {
              key: 0,
              position: "bottom-right",
              offset: newOffset.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  rounded: "",
                  "no-caps": "",
                  color: "secondary",
                  "text-color": "black",
                  class: "q-btn-scroll-fab set-outline",
                  icon: _unref(icon),
                  label: _unref(label),
                  title: _unref(alt),
                  onClick: executeAction
                }, null, 8 /* PROPS */, ["icon", "label", "title"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["offset"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})